<div *ngIf="companyInfoLoaded" class="form-grid">
  <div>
    <div class="form-label">Company Name</div>
    <div class="form-value">{{ companyInfo?.compname }}</div>

    <div class="form-label">Email Address</div>
    <div class="form-value">{{ companyInfo?.reportofficer }}</div>

    <div class="form-label">Title</div>
    <div class="form-value">{{ companyInfo?.title }}</div>

    <div class="form-label">Address</div>
    <div class="form-value">{{ companyInfo?.address }}</div>

    <div class="form-label">City</div>
    <div class="form-value">{{ companyInfo?.city }}</div>

    <div class="form-label">Zip Code</div>
    <div class="form-value">{{ companyInfo?.zipcode }}</div>

    <div class="form-label">Allow Group Reporting?</div>
    <div class="radio-group form-value">
      <input type="radio" [checked]="companyInfo?.groupreport === 'on'" disabled> Yes
      <input type="radio" [checked]="companyInfo?.groupreport !== 'on'" disabled> No
    </div>

    <div class="form-row-adjacent">
      <div>
        <div class="form-label">NAIC Code</div>
        <div class="form-value">{{ companyInfo?.naic || '—' }}</div>
      </div>
      <div>
        <div class="form-label">AM Best</div>
        <div class="form-value">{{ companyInfo?.ambest || '—' }}</div>
      </div>
    </div>
  </div>

  <div>
    <div class="form-label">Preparer's Name</div>
    <div class="form-value">{{ companyInfo?.preparer }}</div>

    <div class="form-label">Additional Email Address</div>
    <div class="form-value">{{ companyInfo?.additionalemail || '—' }}</div>

    <div class="form-label">State</div>
    <div class="form-value">{{ companyInfo?.state }}</div>

    <div class="form-label">Phone Number</div>
    <div class="form-value">{{ companyInfo?.phone }}</div>
  </div>
</div>